import styles from './QuickActions.module.scss'
import QuickActions from './QuickActions'

const QuickActionsContainer = ({ isMobile, triggerCopilot, ...props }) => {
  const { quick_action_cards: quickActionCards } = props
  return (
    <div className={isMobile ? styles.mobile : styles.desktop}>
      <div className={styles.quickActionsContainer}>
        {quickActionCards.map(content => (
          <QuickActions key={content.id} {...content} triggerCopilot={triggerCopilot} />
        ))}
        {props.uid && (
          <div className={styles.uidSection}>
            <span className={styles.uidText}>UID: {props.uid}</span>
          </div>
        )}
      </div>
    </div>
  )
}

export default QuickActionsContainer
